module.exports = __webpack_public_path__ + "media/components/profile/static/icon-arrow-up-96c7e437eb3a4364f9bd656ab307786f.svg";